import { render, staticRenderFns } from "./masrafmerkezinegore.vue?vue&type=template&id=59c50b76&scoped=true"
import script from "./masrafmerkezinegore.vue?vue&type=script&lang=js"
export * from "./masrafmerkezinegore.vue?vue&type=script&lang=js"
import style0 from "./masrafmerkezinegore.vue?vue&type=style&index=0&id=59c50b76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59c50b76",
  null
  
)

export default component.exports